import { EnvironmentProviders } from '@angular/core';
import { initializeApp as angularInitializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { environment } from '../environment/environment';

export function provideFirebase(): EnvironmentProviders[] {
  return [
    provideFirebaseApp(() => angularInitializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideStorage(() => getStorage())
  ];
}
